import { z } from 'zod';

export const AutomaticMappingAction = z.enum(['enable', 'disable']);

export const AutomaticMappingRequestSchema = z.object({
  action: AutomaticMappingAction,
});

export const AutomaticMappingResponseSchema = z.object({
  data: z.object({
    message: z.string(),
    items: z.null(),
    additional: z.null(),
  }),
  error: z.null(),
});

export type AutomaticMappingActionType = z.infer<typeof AutomaticMappingAction>;
